import ACTIONS from "../../constatnts"

export const getFbData = payload => ({
  type: ACTIONS.GET_FB_DATA,
  payload,
})
